module.exports = __webpack_public_path__ + "res/ic_zero_slash.a93840dc353121ae98b559200ff18794.png";